import React from 'react';
import { Query } from 'react-apollo';
import axios from 'axios';
import { Typography, Button, Paper } from '@material-ui/core';
import { EXPORT_URL, TRAIN_STATUS } from '../../../../../graphql/query';
import { apiBaseUrl } from '../../../../../config';

export default class UploadExcel extends React.Component {
  uploadRef = null;

  handleUploadClick = () => {
    this.uploadRef.click();
  };

  handleExportClick = () => {
    console.log('export');
  };

  handleFileChange = async (e, refetch) => {
    try {
      const file = e.target.files[0];
      const fd = new FormData();
      fd.append('file', file, file.name);
      await axios.post(`${apiBaseUrl}/upload`, fd, {
        'Content-Type': 'multipart/form-data',
      });
      refetch();
    } catch (err) {
      console.error(err);
    } finally {
    }
  };

  render() {
    return (
      <Query query={TRAIN_STATUS} pollInterval={5000}>
        {({ loading, error, data, refetch }) => {
          if (loading) return null;
          const isDisabled = data.isTraining;
          return (
            <Paper
              style={{
                padding: '24px',
                display: 'flex',
                margin: '24px 0',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Typography variant="title">
                  Develop Chatbot Training Phrases & Responses
                </Typography>

                <Query query={EXPORT_URL}>
                  {({ loading, error, data }) => {
                    if (loading || !data) {
                      return null;
                    }
                    return (
                      data &&
                      data.exportUrl && (
                        <Button
                          color="primary"
                          variant="contained"
                          disabled={isDisabled}
                          href={data.exportUrl}
                        >
                          Export Template (.xlsx)
                        </Button>
                      )
                    );
                  }}
                </Query>

                <Button
                  color="secondary"
                  variant="contained"
                  disabled={isDisabled}
                  onClick={this.handleUploadClick}
                >
                  Import Template (.xlsx)
                </Button>
                <input
                  ref={e => (this.uploadRef = e)}
                  type="file"
                  name="file"
                  style={{ display: 'none' }}
                  onChange={e => this.handleFileChange(e, refetch)}
                  value=""
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', marginTop: 10 }}>
                <Typography variant="body1">
                  Chatbot will be smart as knowledge you taught it! Tech the Chatbot by export
                  Template .xlsx file
                </Typography>
                <Typography variant="body1">
                  then add Intents, Training Phrases, and Chatbot Response Message, lastly import
                  the file back to system.
                </Typography>
                <Typography variant="body1">
                  Note:{' '}
                  <span style={{ color: 'rgb(225, 0, 80)' }}>
                    Every time you import .xlsx file to system, all previous data will be deleted
                    and replaced by data in latest .xlsx file you imported.
                  </span>
                </Typography>
              </div>
            </Paper>
          );
        }}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/main/content/project/ai/components/UploadExcel.js